import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 py-8" data-id="element-79">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center" data-id="element-80">
        <p className="font-nunito text-sm text-gray-400" data-id="element-81">
          © 2026 Aprendo Jugando · Learning Through Play. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}